import * as React from 'react'

function SvgHomeMobileHeaderBG(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 376 321" fill="none" {...props}>
      <path
        d="M.736 320.024V0h375l-.057 212.831C157.317 259.136.736 320.024.736 320.024z"
        fill="url(#prefix__paint0_radial_home_mobile_header_bg)"
      />
      <defs>
        <radialGradient
          id="prefix__paint0_radial_home_mobile_header_bg"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-99.767 562.932 -256.091) scale(499.25 1963.89)"
        >
          <stop stopColor="#03CAFE" />
          <stop offset={0.523} stopColor="#317CE9" />
          <stop offset={0.958} stopColor="#E9315D" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default SvgHomeMobileHeaderBG
